const  en =  {
 translation: {
  "account": "Account",
  "auth_confirm_read": "I have read and understand",
  "auth_terms_conditions": "Terms & conditions",
  "auto_input_password": "Enter password",
  "auto_input_username": "Enter the username",
  "auto_password": "Password",
  "auto_username": "User name",
  "back_home": "Go back to the main page",
  "cancel_password": "Cancel",
  "change_password": "Change Password",
  "confirm_new_password": "Confirm the new password",
  "coppy_link_error": "Copy link failure",
  "coppy_link_success": "Copy the link successfully",
  "current_password": "Current password",
  "download_file_error": "Download failure",
  "edit_profile_label_cancle": "Cancel",
  "edit_profile_label_confirm": "Confirm",
  "edit_profile_success": "Successful information",
  "edit_profile_text_warning_description": "Are you sure you want to cancel the changes?",
  "email": "Email",
  "error_500": "The system is overloaded, please try again later",
  "error_backhome": "Go back to the main page",
  "error_confirm_new_password": "Unlike the new password",
  "error_new_password": "The new password cannot be like the current password",
  "error_page_note_found": "Page not found",
  "error_password": "The current password is not correct",
  "fan_test_key": "en test",
  "footer_title": "© Copyright belongs to",
  "forgot_password": "Forgot password",
  "forgot_password_change_password_success": "Change password successfully",
  "forgot_password_email_verified_account": "Email has not registered an account",
  "forgot_password_input_placeholder": "Enter your new password",
  "forgot_password_reset_password": "Reset Password",
  "forgot_password_success_title": "Yayy! Change password successfully",
  "forgot_password_title": "You enter the correct registration email to get the password back 😥",
  "handle_redirect": "Redirect",
  "input_confirm_new_password": "Enter a new password",
  "input_current_password": "Enter current password",
  "input_new_password": "Enter your new password",
  "login": "Login",
  "login_error_email_exist": "Email has not registered an account",
  "login_error_email_format": "Email is not in the format.",
  "login_error_email_required": "Please enter your email",
  "login_error_limit_fail": "You have entered the wrong password more than the prescribed number. Please try again later",
  "login_error_password": "Wrong password",
  "login_error_phone_exist": "The phone number has not registered",
  "login_error_phone_format": "The phone number is not in the right format.",
  "login_forget_password": "Do you forget the password?",
  "login_now": "Login now",
  "login_page_close": "Close",
  "login_page_content": "Passio platform for fans",
  "login_page_copy_right": "© Passio -",
  "login_page_password_placeholder": "Enter your password",
  "login_page_placeholder": "Enter your email",
  "login_page_question": "Do not have an account?",
  "login_page_register": "Register now",
  "login_page_title": "Log in",
  "login_password_placeholder": "Enter password",
  "login_phone_placeholder": "Enter your phone number",
  "login_reinstall_password": "Reinstall password",
  "login_success": "Logged in successfully",
  "login_success_title": "Yayy! Logged in successfully",
  "new_password": "A new password",
  "next": "Next",
  "otp_accuracy": "Submit",
  "otp_continute_without_verification": "Continue without authentication",
  "otp_email_title": "The authentication code has been sent to email",
  "otp_error_invalid_email": "Email is not in the format.",
  "otp_error_limit_send_otp": "The number of entry times is over the permitted limit, please send back the new OTP",
  "otp_error_limit_time": "You have manipulated more than the number of times allowed. Please return after {{time}} to continue.",
  "otp_error_otp_not_found": "OTP code does not exist.",
  "otp_error_timeout": "OTP has expired, please send back OTP.",
  "otp_resend": "Send OTP back",
  "otp_screen_please_wait_after": "seconds to send back.",
  "otp_screen_please_wait_before": "Please wait",
  "password": "Password",
  "password_accept_condition": "After pressing the registration button, you accept",
  "password_cancle": "Cancel",
  "password_change": "Change the password",
  "password_confirm": "Confirm",
  "password_error_digit": "Minimum 1 digit",
  "password_error_min_length": "The length is more than 8 characters",
  "password_error_timeout": "Over time setting passwords, please re -operate.",
  "password_error_uppercase": "Minimum 1 capital letters",
  "password_input_placeholder": "E.g: Matkhau112358",
  "password_max": "Please enter maximum {{max}} characters",
  "password_min": "Please enter at least {{min}} characters",
  "password_required": "Please enter this information",
  "password_setup": "Password settings",
  "password_term_condition": "Terms & conditions",
  "phone": "Phone number",
  "register": "Register",
  "register_email_placeholder": "Enter your email address",
  "register_erro_min_length": "Minimum length {{min}} characters",
  "register_error_email_error": "Email is not in the format.",
  "register_error_email_existed": "Email has registered an account",
  "register_error_email_invalid_format": "Email is not in the format.",
  "register_error_limit_send": "You have manipulated more than the number of times allowed. Please return after {{time}} to continue.",
  "register_error_max_length": "Only maximize {{max}} characters",
  "register_error_username_existed": "Username available",
  "register_error_username_matches": "Only allowed characters from a-z and 0-9",
  "register_otp": "OTP authentication",
  "register_page_description": "Create your account and start the journey at Passio",
  "register_page_title": "Register account",
  "register_phone_placeholder": "Enter your phone number",
  "register_success": "Sign Up Success",
  "register_success_description": "Congratulations on your successful account registration. Welcome to the Passio platform",
  "register_success_title": "Yayy! Sign Up Success",
  "register_verified_email": "Email has registered an account",
  "save_password": "Save",
  "save_password_false": "The password has not been changed",
  "save_password_success": "You have successfully changed your password",
  "shoutout_back": "Come back",
  "shoutout_content": "Content",
  "shoutout_create_request": "Create requirements",
  "shoutout_created_at": "Created at",
  "shoutout_decline": "Refuse",
  "shoutout_expired_time": "Expired time",
  "shoutout_feed_back": "Feedback from {{name}}",
  "shoutout_new": "New",
  "shoutout_occasion_advice": "Advice",
  "shoutout_occasion_birthday": "Birthday",
  "shoutout_occasion_mobilize": "Mobilize",
  "shoutout_occasion_other": "Other occasions",
  "shoutout_occasion_question": "Question",
  "shoutout_occasion_special": "Special occasion",
  "shoutout_pronoun_aunt": "Miss",
  "shoutout_pronoun_big_uncle": "Uncle",
  "shoutout_pronoun_bro": "You",
  "shoutout_pronoun_friend": "Friend",
  "shoutout_pronoun_grandfather": "Grandfather",
  "shoutout_pronoun_grandmother": "Grandma",
  "shoutout_pronoun_he": "Older brother",
  "shoutout_pronoun_she": "Older sister",
  "shoutout_pronoun_uncle": "Uncle",
  "shoutout_reject_reason": "The reason for refusal",
  "shoutout_replied": "Made",
  "shoutout_request_code": "Request code",
  "shoutout_request_detail": "Details required",
  "shoutout_request_noti": "Request is being made",
  "shoutout_request_status": "Requirement",
  "shoutout_share": "Share",
  "shoutout_to": "To",
  "spl_add_item_to_live": "Add products to LIVE",
  "spl_add_link": "Find products",
  "spl_add_link_content_success": "MUST CLICK on the link to enter the correct livestream containing your product!",
  "spl_add_link_error_content": "Currently unable to add products to live",
  "spl_add_link_error_title": "Add product to cart Live Error",
  "spl_add_link_title": "Add link",
  "spl_add_link_title_success": "Add products to cart Live success",
  "spl_back": "Back",
  "spl_cannot_add_item_to_shopee_live_session": "Cannot add item to Shopee live",
  "spl_cannot_find_seller": "Can't find live person information",
  "spl_close": "Close",
  "spl_cps_token_is_empty": "Invalid information",
  "spl_go_to_live_label": "Go now",
  "spl_guide_text": "Instructions for using the tool",
  "spl_invalid_url": "Invalid url",
  "spl_item_index": "The product order number in the live basket is",
  "spl_item_link_click_here": "Click this link",
  "spl_link_accept": "Invalid link",
  "spl_link_is_not_empty": "Link cannot be empty",
  "spl_ok": "ok",
  "spl_paste_link_here": "Paste the link here",
  "spl_position_in_live_label": "Position in LIVE",
  "spl_product_already_exists_in_live": "Product already exists in live",
  "spl_product_empty_searching_label": "No products found",
  "spl_product_invalid": "Please enter the correct Shopee product link",
  "spl_related_product_list_header_label": "Shopee deal hunting",
  "spl_related_product_list_title": "Related products are available in live",
  "spl_shopee_session_id_is_empty": "Not ready to live",
  "spl_title": "Shopee live",
  "spl_view_related_product_list_label": "View related products",
  "ss_add_voucher_successs": "Apply successful code",
  "ss_back_donation_detail": "Payment",
  "ss_back_to_homepage_creator": "Back to Creator's Homepage",
  "ss_back_tod_detail": "Pay",
  "ss_brand_gift_cashback": "Cashback",
  "ss_brand_gift_deal_name": "en_Tên deal",
  "ss_brand_gift_deal_price": "en_Giá deal",
  "ss_brand_gift_does_have_gift": "Yes",
  "ss_brand_gift_does_not_have_gift": "No",
  "ss_brand_gift_has_gift": "Gift",
  "ss_brand_gift_heart": "Number of hearts",
  "ss_brand_gift_heart_cashback_heart": "Heart converted",
  "ss_brand_gift_heart_left_heart": "Remaining",
  "ss_brand_gift_heart_link_text": "Click here to view number of hearts",
  "ss_brand_gift_heart_total_heart": "Accumulated hearts",
  "ss_brand_gift_order_amount": "Sale amount",
  "ss_brand_gift_order_support_info": "en_Bạn cần giúp đỡ",
  "ss_brand_gift_payment_history": "Brand Gift",
  "ss_brand_gift_showing_after_heart_text": "Get",
  "ss_brand_gift_showing_before_heart_text": "Number",
  "ss_brand_gift_support_method": "en_Kênh hỗ trợ",
  "ss_brand_gift_title_type_ecommerce": "Online",
  "ss_brand_gift_title_type_o2o": "Offline",
  "ss_brand_gift_voucher": "Used voucher",
  "ss_brand_rating_KOL_domain": "en_Trang KOL",
  "ss_brand_rating_back": "en_Hủy bỏ",
  "ss_brand_rating_back_to_payment_history": "en_Lịch sử mua hàng",
  "ss_brand_rating_button_update_payment_info": "en_Cập nhật ngay",
  "ss_brand_rating_cancel_order": "en_Admin hủy deal đơn hàng",
  "ss_brand_rating_cancel_order_sub_step_1": "en_Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cancel_order_sub_step_2": "en_Bạn đã cập nhật thông tin đánh giá sai 2 lần. Admin từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_cashback": "en_Hoàn",
  "ss_brand_rating_content_1": "en_1. Ảnh đơn hàng yêu cầu các thông tin:",
  "ss_brand_rating_content_2": "en_2. Mã đơn hàng là mã được sàn TMDT cung cấp cho người mua sau khi tiến hành đặt hàng thành công.",
  "ss_brand_rating_content_3": "en_3. Email là thông tin bạn đã cung cấp để đăng ký nhận deal thành công.",
  "ss_brand_rating_content_child_1": "en_Đánh giá 5 sao (bắt buộc)",
  "ss_brand_rating_content_child_2": "en_Nội dung đánh giá tốt về sản phẩm (bắt buộc)",
  "ss_brand_rating_content_child_3": "en_Có ảnh/video về sản phẩm (không bắt buộc)",
  "ss_brand_rating_cover_image_helper": "en_Hỗ trợ: JPG, JPEG, GIF, PNG, BMP, WebP, tối đa 4MB",
  "ss_brand_rating_details_order": "en_Chi tiết đơn hàng",
  "ss_brand_rating_discount": "en_Giảm",
  "ss_brand_rating_edit": "en_Chỉnh sửa",
  "ss_brand_rating_end_time": "en_Hạn Deal",
  "ss_brand_rating_error_404": "en_Bạn không được phép truy cập vào link này",
  "ss_brand_rating_fill_code": "en_Mã đơn hàng",
  "ss_brand_rating_fill_email": "Email",
  "ss_brand_rating_get_cashback_from_passio": "en_Nhận hoàn tiền từ Passio",
  "ss_brand_rating_get_cashback_from_passio_sub": "en_Thời gian hoàn tiền tối đa trong 7 ngày. Trong trường hợp chưa cung cấp thông tin thanh toán, bạn cần cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_order_code": "en_Mã đơn hàng",
  "ss_brand_rating_order_content_child_1": "en_Tên sản phẩm trùng với tên sản phẩm của deal",
  "ss_brand_rating_order_content_child_2": "en_Mã đơn hàng",
  "ss_brand_rating_order_content_child_3": "en_Khoảng thông báo xác nhận chờ thanh toán (COD) và chờ vận chuyển (đã thanh toán)",
  "ss_brand_rating_order_heart": "en_Tim tích lũy",
  "ss_brand_rating_placeholder_code": "en_Nhập mã đơn hàng",
  "ss_brand_rating_register_deal_time": "en_Thời gian đăng ký Deal",
  "ss_brand_rating_save": "en_Lưu",
  "ss_brand_rating_showing_after_heart_text": "en_Danh sách sản phẩm",
  "ss_brand_rating_status": "en_Trạng thái",
  "ss_brand_rating_status_failed": "en_Từ chối",
  "ss_brand_rating_status_new": "en_Đang chờ",
  "ss_brand_rating_status_success": "en_Thành công",
  "ss_brand_rating_step_0_description": "en_Đơn hàng đăng ký từ hệ thống",
  "ss_brand_rating_step_0_title": "en_Đăng ký nhận Deal",
  "ss_brand_rating_step_1_description": "en_Upload ảnh đơn hàng hợp lệ và cập nhật các thông tin yêu cầu.",
  "ss_brand_rating_step_1_description_fail": "en_Bạn đã cập nhật thông tin đơn hàng sai. Admin đã từ chối lượt mua deal hoàn tiền của bạn.",
  "ss_brand_rating_step_1_fail": "en_Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_1_pending": "en_Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_1_title": "en_Cập nhật đơn hàng",
  "ss_brand_rating_step_2_description": "en_Upload ảnh đánh giá của bạn về sản phẩm mà bạn đã nhận",
  "ss_brand_rating_step_2_fail": "en_Admin đã từ chối thông tin ảnh của bạn",
  "ss_brand_rating_step_2_pending_1": "en_Đơn hàng đang chờ admin xét duyệt",
  "ss_brand_rating_step_2_pending_2": "en_Bạn đã cập nhật sai thông tin. Chỉ còn 1 lần để bạn cập nhật lại.",
  "ss_brand_rating_step_2_title": "en_Đánh giá đơn hàng 5*",
  "ss_brand_rating_step_3_description": "en_Thời gian hoàn tiền tối đa trong 7 ngày. Trường hợp bạn chưa cung cấp thông tin thanh toán, vui lòng cập nhật để nhận hoàn tiền.",
  "ss_brand_rating_step_3_description_clamp_heath": "en_Số tiền được hoàn tương đương với",
  "ss_brand_rating_step_3_description_done": "en_Thời gian hoàn tiền tối đa trong 7 ngày.",
  "ss_brand_rating_step_3_description_heart": "en_{{heart}}❤.",
  "ss_brand_rating_step_3_title": "en_Nhận hoàn tiền từ Passio",
  "ss_brand_rating_text_cash_back": "en_Hoàn tiền",
  "ss_brand_rating_text_percent": "en_Hoàn",
  "ss_brand_rating_title": "en_Tải ảnh đơn hàng",
  "ss_brand_rating_title_detail_order": "en_Chi tiết đơn hàng",
  "ss_brand_rating_title_hepler": "en_Lưu ý:",
  "ss_brand_rating_title_upload_rating": "en_Tải ảnh đánh giá đơn hàng",
  "ss_brand_rating_toast_success": "en_Bạn đã gửi thông tin thành công",
  "ss_brand_rating_update_order": "en_Cập nhật đơn đặt hàng",
  "ss_brand_rating_update_order_sub": "en_Bạn cần cập nhật thông tin mua đơn hàng thành công.",
  "ss_brand_rating_update_payment": "en_Câp nhật thông tin thanh toán",
  "ss_brand_rating_update_payment_info": "en_Cập nhật thanh toán",
  "ss_brand_rating_update_rating_sub": "en_Bạn cần cập nhật thông tin đánh giá 5 sao về sản phẩm",
  "ss_brand_rating_upload_cover_image": "en_Ảnh đơn hàng",
  "ss_brand_rating_upload_file_format_invalid_content": "Invalid image format. Supported format: JPG, JPEG, GIF, PNG, BMP, WebP",
  "ss_brand_rating_upload_file_size_invalid_content": "Please choose a file with a maximum size of 10MB",
  "ss_brand_rating_upload_order": "en_Tải ảnh đơn hàng",
  "ss_brand_rating_upload_order_again": "en_Tải lại ảnh đơn hàng",
  "ss_brand_rating_upload_rating": "en_Cập nhật thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_rating_again": "en_Cập nhật lại thông tin đánh giá 5 sao",
  "ss_brand_rating_upload_success_modal_order": "en_Chúc mừng bạn đã tải ảnh đơn hàng thành công! Bạn có thể theo dõi thêm lịch sử và trạng thái mua hàng.",
  "ss_brand_rating_upload_success_modal_rating": "en_Để nhận được hoàn tiền của chúng tôi, bạn cần cập nhật thông tin thanh toán",
  "ss_brand_rating_validate_code": "en_Trường dữ liệu không được để trống",
  "ss_brand_rating_validate_upload": "en_Trường dữ liệu không được để trống",
  "ss_call_hotline": "Call the hotline",
  "ss_checkout_disclamer_content_popup_tiktok": "To have a more streamlined payment process, please choose \"Open in browser\"",
  "ss_checkout_disclamer_popup_tiktok": "Disclaimer",
  "ss_checkout_email_after": "The part of '@' does not contain the icon ''",
  "ss_checkout_email_before": "The back of '@' does not contain the icon ''",
  "ss_checkout_email_duplicate": "The part behind '@' must not contain the '@'",
  "ss_checkout_email_must": "Please include '@' in mail.",
  "ss_checkout_phone_require": "Please enter the phone number",
  "ss_checkout_select_voucher": "You have discount code?",
  "ss_checkout_voucher_empty_text": "No discount code",
  "ss_checkout_voucher_empty_text_suggest": "To add discount codes, please enter & press the \"Application\" button on the top",
  "ss_convert_heart_amount_error": "Not enough accumulated heart",
  "ss_convert_heart_button": "Heart conversion",
  "ss_convert_heart_choose_phone_scratch_card": "Choose card value",
  "ss_convert_heart_convert_btn_cancle": "Cancel",
  "ss_convert_heart_convert_btn_confirm": "Confirm",
  "ss_convert_heart_error_phone_format": "Enter the correct phone number",
  "ss_convert_heart_error_phone_required": "Enter phone number",
  "ss_convert_heart_info_1_hearts_convert": "1 heart",
  "ss_convert_heart_instruct_phone_number": "Please enter the exact phone number that you wish to receive money",
  "ss_convert_heart_number_convert": "Converted number of hearts",
  "ss_convert_heart_phone_number_input": "Phone number",
  "ss_convert_heart_placeholder_phone_number": "Enter phone number",
  "ss_convert_heart_request_existed": "A heart conversion request is currently pending approval. Please try again later",
  "ss_convert_heart_send_request_convert": "Send request",
  "ss_convert_heart_success": "Conversion request sent successfully. Please wait 3 - 5 days",
  "ss_convert_heart_title_popup": "Create a heart conversion request",
  "ss_convert_heart_verify_account_btn_cancel": "Cancel",
  "ss_convert_heart_verify_account_btn_confirm": "Account verification",
  "ss_convert_heart_warning_account_des_1": "Please access",
  "ss_convert_heart_warning_account_des_2": "Personal information",
  "ss_convert_heart_warning_account_des_3": "To verify your account",
  "ss_convert_heart_warning_convert_des": "Are you sure you want to convert your heart for phone credit for this phone number?",
  "ss_convert_heart_warning_convert_title": "Confirm ?",
  "ss_copied": "Copied",
  "ss_copy_failed": "Copy failed",
  "ss_create_account_donation": "Create Account",
  "ss_creator": "Creator",
  "ss_creator_tod": "Creator",
  "ss_decline_status_tod": "Refuse",
  "ss_details": "Details",
  "ss_disable_referral_button_share": "The event has ended",
  "ss_discount_ammount": "Discount",
  "ss_donate_success": "Successful lucky money",
  "ss_donation_btn_checkout": "Send",
  "ss_donation_checkout_email_notification": "👉 Your product will be sent via email, please enter your correct email address.",
  "ss_donation_checkout_email_title": "Email",
  "ss_donation_checkout_phone_placeholder": "09xxxxxx",
  "ss_donation_checkout_phone_title": "Phone number",
  "ss_donation_checkout_private_message_title": "Send your message in private mode",
  "ss_donation_checkout_user_message_title": "Message to the Creator",
  "ss_donation_code": "Support code",
  "ss_donation_confirm_leave_order": "Your settings have not been saved. Do you want to leave this page?",
  "ss_donation_message_from_user": "Message from you",
  "ss_donation_name_kol": "Donate",
  "ss_donation_pending_title": "The exchange is under process",
  "ss_donation_time": "Support time",
  "ss_donation_user_message_placeholder": "Say something to the Creator 🤑",
  "ss_duplicate_email": "Email has registered an account",
  "ss_duplicate_username": "Username available",
  "ss_edit_profile": "Edit records",
  "ss_email": "Email",
  "ss_enter_course": "Join now",
  "ss_error_not_enough_money": "Error occurs, currently cannot be paid",
  "ss_expired_voucher": "Sorry! This discount code has expired",
  "ss_fail_name_kol": "failure",
  "ss_fan_add_voucher_button": "Apply",
  "ss_fan_brand_gift_title": "en_ƯU ĐÃI THƯƠNG HIỆU",
  "ss_fan_brand_rating_title": "en_GIAN HÀNG BÍ MẬT",
  "ss_fan_checkout_total_price": "Total",
  "ss_fan_date_picker_text_custom_range": "en_Tùy chỉnh khoảng thời gian",
  "ss_fan_date_picker_text_last_n_day": "en_{{n}} ngày gần nhất",
  "ss_fan_date_picker_text_last_week": "en_Tuần trước",
  "ss_fan_date_picker_text_this_month": "en_Tháng này",
  "ss_fan_date_picker_text_this_week": "en_Tuần này",
  "ss_fan_date_picker_text_today": "en_Hôm nay",
  "ss_fan_date_picker_text_yesterday": "en_Hôm qua",
  "ss_fan_empty_heart": "There is no heart conversion order",
  "ss_fan_exclusive_passio_badge": "Exclusive",
  "ss_fan_input_voucher_placeholder": "Insert code",
  "ss_fan_my_title": "My discount code",
  "ss_fan_no_photo_has_been_selected": "en_Chưa có ảnh nào được chọn",
  "ss_fan_profile_help_channel_fb": "Kênh hỗ trợ",
  "ss_fan_profile_help_email": "Email",
  "ss_fan_profile_help_popup_title": "Trợ giúp",
  "ss_fan_profile_info": "Personal information",
  "ss_fan_upload_button_label": "en_Tải ảnh lên",
  "ss_fan_voucher_label_date": "Expired:",
  "ss_fe_fan_edit_profile_cancel_button": "en_Hủy",
  "ss_fe_fan_edit_profile_confirm_button": "en_Xong",
  "ss_fe_fan_edit_profile_label_confirm": "Confirm",
  "ss_fe_fan_edit_profile_personal_tax_code_had": "en_Đã có",
  "ss_fe_fan_edit_profile_personal_tax_code_had_not": "en_Chưa có",
  "ss_fe_fan_edit_profile_title_calender": "en_Chọn ngày",
  "ss_fe_fan_edit_profile_validate_date_identification": "en_Ngày cấp không hợp lệ",
  "ss_fe_fan_edit_profile_validate_invalid": "Invalid data format",
  "ss_fe_fan_edit_profile_validate_max_length": "Please enter upto {{num}} characters",
  "ss_fe_fan_edit_profile_validate_number_0_to_9": "Please enter numbers only (0-9)",
  "ss_fe_fan_edit_profile_validate_required": "Data field must not be blank",
  "ss_fe_fan_edit_profile_validate_required_file": "en_Trường dữ liệu không được để trống 1 trong 2",
  "ss_fe_fan_profile_address_user": "en_Địa chỉ",
  "ss_fe_fan_profile_address_user_placeholder": "en_Nhập địa chỉ của bạn",
  "ss_fe_fan_profile_country_alias": "Country",
  "ss_fe_fan_profile_country_chosen": "Select country",
  "ss_fe_fan_profile_country_helper": "Select the country corresponding to your payment account",
  "ss_fe_fan_profile_momo_account": "Momo account",
  "ss_fe_fan_profile_momo_account_helper": "This field must match the recipient account name and must not be changed",
  "ss_fe_fan_profile_momo_account_name": "Account name",
  "ss_fe_fan_profile_momo_account_name_placeholder": "Enter account name",
  "ss_fe_fan_profile_momo_phone_placeholder": "Enter MoMo account",
  "ss_fe_fan_profile_payment_account_name": "Account name",
  "ss_fe_fan_profile_payment_account_number": "Account number",
  "ss_fe_fan_profile_payment_account_number_placeholder": "Enter account number",
  "ss_fe_fan_profile_payment_alias": "Payment",
  "ss_fe_fan_profile_payment_bank_account": "Bank account",
  "ss_fe_fan_profile_payment_bank_alias": "Beneficiary bank",
  "ss_fe_fan_profile_payment_bank_name_placeholder": "Enter your beneficiary bank name",
  "ss_fe_fan_profile_payment_branch": "Branch",
  "ss_fe_fan_profile_payment_branch_new_placeholder": "en_Nhập chi nhánh ngân hàng của bạn",
  "ss_fe_fan_profile_payment_branch_placeholder": "Enter bank name",
  "ss_fe_fan_profile_payment_date_identification": "en_Ngày phát hành KTP",
  "ss_fe_fan_profile_payment_file_back": "en_Mặt sau",
  "ss_fe_fan_profile_payment_file_front": "en_Mặt trước",
  "ss_fe_fan_profile_payment_file_helper": "en_Đính kèm 2 ảnh KTP của bạn: Mặt trước, mặt sau. Yêu cầu tải lên hình ảnh rõ ràng, chi tiết.",
  "ss_fe_fan_profile_payment_identification": "en_Số KTP",
  "ss_fe_fan_profile_payment_identification_placeholder": "en_Nhập số KTP",
  "ss_fe_fan_profile_payment_image_identification": "en_Ảnh KTP(Passport)",
  "ss_fe_fan_profile_payment_personal_tax": "en_Mã số thuế",
  "ss_fe_fan_profile_payment_personal_tax_placeholder": "en_Nhập mã số thuế cá nhân",
  "ss_fe_fan_profile_tl_alias": "Thailand",
  "ss_fe_fan_profile_vn_alias": "Vietnam",
  "ss_fe_fan_voucher_title": "Discount code",
  "ss_for_you": "Send to you 🤗",
  "ss_hotline": "Hotline",
  "ss_label_tod_link_success": "Single information truth or dare has been sent to email",
  "ss_lable_back_success_donation": "Details support",
  "ss_lable_back_success_tod": "Payment details",
  "ss_lable_link_success": "Support information has been sent to email",
  "ss_logout": "Logout",
  "ss_modal_timeout_register_now": "Register now",
  "ss_next_register": "Create Account",
  "ss_no": "Are not",
  "ss_order_code": "Code orders",
  "ss_order_date": "Time Order",
  "ss_order_detail": "Order details",
  "ss_order_fail": "Order failed",
  "ss_order_history_accepted": "Waiting",
  "ss_order_history_empty_text": "You currently do not have any products",
  "ss_order_history_empty_text_suggest": "Please buy products to support KOL",
  "ss_order_history_new": "New",
  "ss_order_history_refund": "Refund",
  "ss_order_history_replied": "Made",
  "ss_order_history_reply_text": "Reply",
  "ss_order_message_from_kol": "Feedback from KOL",
  "ss_order_message_from_user": "Message from you",
  "ss_order_momo_wallet": "MOMO E-WALLET",
  "ss_order_note_lucky_sent_email": "Lucky money has been sent to email",
  "ss_order_note_sent_email": "Orders have been sent to email",
  "ss_order_pending": "Transaction is being processed",
  "ss_order_pending_title": "Transaction is being processed",
  "ss_order_success": "Order Success",
  "ss_order_tod_date": "Payment time",
  "ss_order_tod_message_from_kol": "Response from Creator",
  "ss_payment_GBPRIMEPAY_CREDIT_CARD": "Credit Cards",
  "ss_payment_GBPRIMEPAY_QRCASH": "PromptPay",
  "ss_payment_GBPRIMEPAY_RABBIT_LINEPAY_WALLET": "LinePay",
  "ss_payment_GBPRIMEPAY_SHOPEEPAY_WALLET": "ShopeePay Wallet",
  "ss_payment_GBPRIMEPAY_TRUEMONEY_WALLET": "TrueMoney Wallet",
  "ss_payment_GBPRIMEPAY_WECHAT_WALLET": "Wechat Wallet",
  "ss_payment_history": "Order history",
  "ss_payment_history_brand_rating": "en_Brand Ratings",
  "ss_payment_history_digital_product": "Digital Product",
  "ss_payment_history_donation": "Donation",
  "ss_payment_history_gift": "Gift",
  "ss_payment_history_tod": "Truth or dare",
  "ss_payment_method": "Payment methods",
  "ss_payment_vnpay_qr_description": "en_Nhớ dùng mã giảm giá VNPAY bạn nhé!",
  "ss_payment_xendit_dana": "Dana Wallet",
  "ss_payment_xendit_gcash": "GCash Wallet",
  "ss_payment_xendit_grabpay": "GrabPay Wallet",
  "ss_payment_xendit_ovo": "Ovo Wallet",
  "ss_payment_xendit_paymaya": "PayMaya Wallet",
  "ss_payment_xendit_shopeepay": "Shopeepay indo",
  "ss_payment_xendit_virtual_account": "Virtual Account",
  "ss_payment_xendit_virtual_account_bottom": "Bank Transfer",
  "ss_placeholder_profile_email": "Enter the email",
  "ss_placeholder_profile_fullname": "Enter your full name",
  "ss_placeholder_profile_fullphone": "Enter your phone number",
  "ss_placeholder_profile_username": "Enter the username",
  "ss_price_max_discount": "Minimize",
  "ss_product_name": "Product's name",
  "ss_profile": "Profile",
  "ss_profile_account_not_acctive": "The account is not authenticated",
  "ss_profile_active_account": "Authenticated now",
  "ss_profile_btn_edit": "Edit information",
  "ss_profile_btn_edit_cancel": "Cancel",
  "ss_profile_btn_edit_save": "Save",
  "ss_profile_change_email_success": "Successful information",
  "ss_profile_email": "Email",
  "ss_profile_error_email": "Please enter the correct email format",
  "ss_profile_error_email_required": "Please enter the email",
  "ss_profile_error_username_existed": "Username available",
  "ss_profile_error_username_matches": "Only allowed characters from A-Z and 0-9",
  "ss_profile_error_username_required": "Please enter the username",
  "ss_profile_fullname": "Full name",
  "ss_profile_fullname_error_max_length": "Please enter maximum {{max}} characters",
  "ss_profile_fullphone": "Phone number",
  "ss_profile_fullphone_error": "You enter the correct phone number",
  "ss_profile_helptext_email": "If you change your email, you will need to authenticate your account",
  "ss_profile_helptext_email_actived": "Email has been verified",
  "ss_profile_username": "user name",
  "ss_profile_username_error_max_length": "Only allow up to 255 characters",
  "ss_question_dare_for_you": "Challenges from you",
  "ss_question_truth_for_you": "Questions from you",
  "ss_recurring_payment_button_submit": "Subscription",
  "ss_recurring_payment_field_email": "Email",
  "ss_recurring_payment_field_full_name": "Full name",
  "ss_recurring_payment_field_phone": "Phone number",
  "ss_recurring_payment_helper_field_email": "Your product will be sent via email, please enter it correctly.",
  "ss_recurring_payment_info_title": "Customer info",
  "ss_recurring_payment_month": "Month",
  "ss_recurring_payment_placeholder_field_email": "Your@example.com",
  "ss_recurring_payment_placeholder_field_full_name": "Enter full name ",
  "ss_recurring_payment_placeholder_field_phone": "Enter phone number",
  "ss_referral_button_share": "Refer your friends now",
  "ss_referral_campaign": "Refer your friends now",
  "ss_referral_copy_link_error": "Failed to copy referral link",
  "ss_referral_copy_link_success": "Sucessfully copied referral link",
  "ss_referral_creator_name": "Creator",
  "ss_referral_intro_step_1": "Copy the product referral link",
  "ss_referral_intro_step_1_title": "Step 1:",
  "ss_referral_intro_step_2": "Share with your friends",
  "ss_referral_intro_step_2_title": "Step 2:",
  "ss_referral_intro_step_3": "Earn a bonus when your friends make a successful purchase",
  "ss_referral_intro_step_3_title": "Step 3:",
  "ss_referral_intro_title_page": "Refer your friends & get rewarded",
  "ss_referral_reward_recived": "Your reward",
  "ss_referral_text_intro_description": "The prize you've receive is \"Heart\" on Passio. This prize will be converted to scratch card for mobile phone. The more friend you refer, the more rewards you can get. Why not refer your friends now!",
  "ss_referral_text_title": "Your currently selected referral product",
  "ss_referral_title_page": "Refer your friends",
  "ss_register_link_to_login_page": "Login",
  "ss_register_success": "Successful account registration",
  "ss_retry": "Retry",
  "ss_showing": "Showing",
  "ss_store_btn_checkout": "Pay",
  "ss_store_can_not_place_order": "Can't place order at this moment. Please try again later",
  "ss_store_checkout_email_notification": "👉 Your product will be sent via email, enter exactly.",
  "ss_store_checkout_email_notification_bg": "Your product will be sent via email, enter exactly.",
  "ss_store_checkout_email_title": "Email",
  "ss_store_checkout_error_E1": "The discount code does not exist!",
  "ss_store_checkout_error_E2": "Sorry! This discount code has expired",
  "ss_store_checkout_error_E3": "Not yet to use the code. Please try again later!",
  "ss_store_checkout_error_E4": "Oppp. The discount code has expired",
  "ss_store_checkout_error_E5": "You have purchased this course. Please check your order history",
  "ss_store_checkout_error_EC": "The product is not available",
  "ss_store_checkout_error_EC1": "Out of stock",
  "ss_store_checkout_error_ES": "Can't order, please again later",
  "ss_store_checkout_phone_placeholder": "09xxxxxx",
  "ss_store_checkout_phone_title": "Phone number",
  "ss_store_checkout_private_message_title": "Set a message in private mode",
  "ss_store_checkout_user_message_title": "Message",
  "ss_store_confirm_leave_order": "Do you want to leave here?",
  "ss_store_copy_successfully": "Copy successfully",
  "ss_store_copy_to_other_brower": "Please copy this path and paste it into Safari to proceed",
  "ss_store_copy_url": "Copy the path",
  "ss_store_create_account": "Create Account ?",
  "ss_store_customer_information": "Customer information",
  "ss_store_donation": "Donation information",
  "ss_store_donation_payment_title": "Select a payment method",
  "ss_store_email_require": "Please enter email",
  "ss_store_free": "Free of charge",
  "ss_store_invalid_email": "You enter the correct email format",
  "ss_store_invalid_phone": "Your phone number is invalid",
  "ss_store_invalid_username": "Only allowed characters are ordinary words from a-z and 0-9",
  "ss_store_leave": "Leave",
  "ss_store_momo_wallet": "MOMO E-WALLET",
  "ss_store_order_detail": "Pay",
  "ss_store_order_item": "Product information",
  "ss_store_password_min_length": "The minimum length of 6 characters",
  "ss_store_password_require": "Please enter the password",
  "ss_store_payment_deeplink": "Payment link",
  "ss_store_phone_require": "Your phone number is invalid",
  "ss_store_require_payment": "Please select a payment method",
  "ss_store_shopeepay_wallet": "Shopeepay e -wallet",
  "ss_store_shoutout_item": "Video information shoutout",
  "ss_store_tod_user_message_max_length": "Exceeded 500 characters.",
  "ss_store_user_message_max_length": "Some information exceeds the character allowed to enter, check it again",
  "ss_store_user_message_passio_placeholder": "Please text us!",
  "ss_store_user_message_placeholder": "You try something with the creator 🤑",
  "ss_store_user_message_tooltip": "The message is not publicly displayed anywhere, just you and Creator can see",
  "ss_store_username_max_length": "Only allow up to 255 characters",
  "ss_store_username_require": "Please enter the username",
  "ss_store_virtual_item": "Gift information",
  "ss_store_vnpay_atm": "ATM card",
  "ss_store_vnpay_atm_description": "Internet banking support",
  "ss_store_vnpay_credit_card": "International credit / debit card",
  "ss_store_vnpay_qr": "VNPAY-QR / Internet banking",
  "ss_success_name_kol": "success",
  "ss_suggest_register_modal_content_text": "You need to log in or register to continue using our services",
  "ss_support_channel": "Support channel",
  "ss_support_email_info": "info@passio.eco",
  "ss_support_facebook": "Facebook",
  "ss_support_info": "Support information",
  "ss_support_phone_info": "024.77700700",
  "ss_title_tod_dare": "Details on Dare",
  "ss_title_tod_truth": "Details on Truth",
  "ss_tod_checkout_email_notification": "👉 Details on your challenge will be sent via email. Make sure you typed the correct email address.",
  "ss_tod_checkout_user_message_title": "Challenge Details",
  "ss_tod_dare_btn_checkout": "Send",
  "ss_tod_dare_code": "Code dare",
  "ss_tod_dare_name_kol": "Send challenges to",
  "ss_tod_email_require": "Type your email address",
  "ss_tod_invalid_email": "Type your valid email address",
  "ss_tod_invalid_phone": "Type your correct phone number",
  "ss_tod_message_require": "You cannot leave this blank",
  "ss_tod_pending_title": "The exchange is under process",
  "ss_tod_phone_require": "Type your phone number",
  "ss_tod_truth_btn_checkout": "Send",
  "ss_tod_truth_code": "Code Truth",
  "ss_tod_truth_name_kol": "Send questions to",
  "ss_tod_user_message_placeholder": "Say something to the Creator 🤑",
  "ss_total_price": "Total",
  "ss_verify_account_success": "Congratulations. You have successfully verified your account",
  "ss_video_shoutout_to": "Send a request to {{creator_name}}",
  "ss_view_detail": "See details",
  "ss_voucher_has_not_been_used": "Not yet to use the code. Please try again later!",
  "ss_voucher_not_exist": "The discount code does not exist!",
  "ss_voucher_out_of_use": "Oppp. The discount code has expired",
  "ss_watch_content": "See content",
  "ss_watch_order_history": "The product has been purchased",
  "ss_your_voucher_code": "Your discount code",
  "sure_cancle_password": "Are you sure you want to cancel the changes?",
  "system_error": "System error",
  "title_checkout": "Passio - Payment",
  "username": "Username",
  "username_placeholder": "Enter the username",
  "video_shoutout": "Video shoutout"
} 
} 
export default en